// extracted by mini-css-extract-plugin
export default {"heading":"Login_heading__Cxftc","form":"Login_form__koM9h","field":"Login_field__A87G5","extra_field":"Login_extra_field__Goak5","signup":"Login_signup__9kgwi"};